import React from "react";
import {Button, Popconfirm} from "antd";
import {useTranslation} from "react-i18next";
import {DeleteOutlined} from "@ant-design/icons";
import {useStore} from "../../../../../../../hooks/useStore";

export const UnassignDisallowedPermissionPolicyButton = ({
    userId,
    permissionPolicyKey,
    recall = () => {}
}) => {
    const stores = useStore();
    const {t} = useTranslation(["userAuthorization"]);

    return (
        <Popconfirm
            title={t("components.unassignDisallowedPermissionPolicyButton.title", {
                ns: "userAuthorization"
            })}
            onConfirm={async () => {
                const unassignDisallowedPermissionPolicyResult = await stores.userStore.unassignDisallowedPermissionPolicy(
                    {userId, permissionPolicyKey}
                );
                if (!unassignDisallowedPermissionPolicyResult.success) return;
                recall();
            }}
            okText={t("modal.yesButton", {ns: "common"})}
            cancelText={t("modal.noButton", {ns: "common"})}
            placement="left"
        >
            <Button
                data-testid="unassignDisallowedPermissionPolicyButton"
                disabled={false}
                loading={false}
                icon={<DeleteOutlined />}
                onClick={e => e.stopPropagation()}
            ></Button>
        </Popconfirm>
    );
};
